import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../_App/Redux/hooks";
import {
  SelectedOrganisations,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Filtre from "./Filtre";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import { Form, Spinner } from "react-bootstrap";
import {
  findStockBySocieteApi,
  stockfilterApi,
} from "../../_App/Redux/Slices/article/articleSlice";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../_App/Redux/Slices/organisations/organisationSlice";
import { findDepotsBySocieteApi } from "../../_App/Redux/Slices/depot/depotSlice";
import {
  calculerTotalStock,
  findAvanceTransfer,
  findStockPositiveOrg,
  generateUniqueColor,
  StockArticle,
  StockOrganisation,
} from "../../_App/Helpers/helpers";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";

export default function StockTableArticle({
  t,
  listDepots,
  stock,
  stock_Organisation,
  index,
  setindex,
  liststock,
  handleSearch,
  setkeyword,
  keyword,
  spinner,
  setspinner,
  setdatafilter,
  dispatch,
  societe,
  setNLigne,
  NLigne,
}: any) {
  const [Filtredlist_article, setFiltredlist_article] = useState<any[]>([]);
  const [list_article, setlist_article] = useState<any[]>([]);
  const [selectedCarte, setSelectedCarte] = useState<any[]>([]);
  const [selectedCategorie, setSelectedCategorie] = useState<any[]>([]);
  const [selectedSousCategorie, setSelectedSousCategorie] = useState<any[]>([]);
  const [intervaleRef, setintervaleRef] = useState<any>();
  const [intervalePrix, setintervalePrix] = useState<any>();
  const [showtotalStock, setShowtotalStock] = useState(false);
  const [showDepots, setshowDepots] = useState(false);
  const [OrgDepots, setOrgDepots] = useState<null | string>(null);
  const [categoriesOptions, setcategoriesdOptions] = useState<any[]>([]);
  const [souscategoriesOptions, setsouscategoriesdOptions] = useState<any[]>(
    [],
  );
  interface SelectionsState {
    [key: string]: any[];
  }
  const parametrage = useAppSelector(parametrageCaisse);

  const [selections, setSelections] = useState<SelectionsState>({});
  const list_organisation = useAppSelector(ListOrganisations);
  const organisationHasValue = (stockList: any[], orgId: string | number): boolean => {
  return stockList?.some((itemData) => {
    // 1. Calculate Initial Stock
    const stockIni = itemData?.stock?.[orgId]?.reduce(
      (acc: number, rec: any) => acc + (rec?.stock || 0),
      0
    ) || 0;

    if (stockIni > 0) return true;

    // 2. Calculate Advance Quantity
    const qteAvance = itemData?.avance?.[orgId]?.reduce(
      (sum: number, item: any) => sum + (item?.quantite || 0),
      0
    ) || 0;

    if (qteAvance > 0) return true;

    // 3. Calculate Transfer Quantity
    const qteTransfert = itemData?.transfer?.[orgId]?.reduce(
      (sum: number, item: any) => sum + (item?.quantite || 0),
      0
    ) || 0;

    
    return qteTransfert > 0;
  });
};
  const visibleOrganisations = list_organisation?.filter((item: any) =>
    organisationHasValue(stock, item._id),
  );
  const [article_defectueux, setarticle_defectueux] = useState<boolean>(false);
  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setarticle_defectueux(event.target.checked);
  };
  useEffect(() => {
    if (stock) {
      let nouveauTableau = stock
        ? stock.map((element: any) => (element ? element["article_id"] : null))
        : [];
      function removeDuplicates(objects: any[]) {
        let seen = new Set();
        return objects.filter((obj) => {
          if (seen.has(obj?._id)) {
            return false;
          }
          seen.add(obj?._id);
          return true;
        });
      }

      // Appeler la fonction pour supprimer les doublons
      if (nouveauTableau.length !== 0) {
        let objectsWithoutDuplicates = removeDuplicates(nouveauTableau);

        setFiltredlist_article(objectsWithoutDuplicates);
        setlist_article(objectsWithoutDuplicates);
      }
    }
  }, [stock]);

  const searchfiltre = () => {
    setspinner(true);
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      motcle: keyword,
      index: 1,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      Nligne: NLigne || 200,
      societe: societe,
    };
    setindex(1);
    setdatafilter(data);
    dispatch(stockfilterApi(data));
  };

  const calculstock = (itemdata: any, orgId: any, dep: any) => {
    const stockIni = itemdata?.stock[orgId]?.find(
      (d: any) => d.depots_id?._id === dep?._id,
    )?.stock;
    if (stockIni > 0) {
      return stockIni;
    } else {
      if (dep.defaut) {
        if (itemdata?.avance[orgId]) {
          const QteAvance = itemdata?.avance[orgId]?.reduce(
            (sum: any, item: any) => sum + item.quantite,
            0,
          );
          if (QteAvance > 0) {
            return <p style={{ color: "red" }}>(A){QteAvance}</p>;
          } else {
            return stockIni || 0;
          }
        }
        if (itemdata?.transfer[orgId]) {
          const QteTransfer = itemdata?.transfer[orgId]?.reduce(
            (sum: any, item: any) => sum + item.quantite,
            0,
          );
          if (QteTransfer > 0) {
            return <p style={{ color: "red" }}>(T){QteTransfer}</p>;
          } else {
            return stockIni || 0;
          }
        } else {
          return stockIni || 0;
        }
      } else {
        return stockIni || 0;
      }
    }
  };
  const calculstockOrga = (itemdata: any, orgId: any) => {
    const stockIni = itemdata?.stock[orgId]?.reduce(
      (acc: any, rec: any) => acc + (rec.stock || 0),
      0,
    );
    if (stockIni > 0) {
      return stockIni;
    } else {
      if (itemdata?.avance[orgId]) {
        const QteAvance = itemdata?.avance[orgId]?.reduce(
          (sum: any, item: any) => sum + item.quantite,
          0,
        );
        if (QteAvance > 0) {
          return <p style={{ color: "red" }}>(A){QteAvance}</p>;
        } else {
          return stockIni || 0;
        }
      }
      if (itemdata && itemdata?.transfer && itemdata?.transfer[orgId]) {
        const QteTransfert = itemdata?.transfer[orgId]?.reduce(
          (sum: any, item: any) => sum + item.quantite,
          0,
        );
        if (QteTransfert > 0) {
          return <p style={{ color: "red" }}>(T){QteTransfert}</p>;
        } else {
          return stockIni || 0;
        }
      } else {
        return stockIni || 0;
      }
    }
  };

  return (
    <div>
      <div className="row layout-spacing">
        <Filtre
          spinner={spinner}
          handleSearch={handleSearch}
          setkeyword={setkeyword}
          t={t}
          setspinner={setspinner}
          setdatafilter={setdatafilter}
          setindex={setindex}
          searchfiltre={searchfiltre}
          selectedCarte={selectedCarte}
          setSelectedCarte={setSelectedCarte}
          selectedCategorie={selectedCategorie}
          setSelectedCategorie={setSelectedCategorie}
          selectedSousCategorie={selectedSousCategorie}
          setSelectedSousCategorie={setSelectedSousCategorie}
          categoriesOptions={categoriesOptions}
          setcategoriesdOptions={setcategoriesdOptions}
          souscategoriesOptions={souscategoriesOptions}
          setsouscategoriesdOptions={setsouscategoriesdOptions}
          selections={selections}
          setintervaleRef={setintervaleRef}
          intervaleRef={intervaleRef}
          setintervalePrix={setintervalePrix}
          intervalePrix={intervalePrix}
          setSelections={setSelections}
          setNLigne={setNLigne}
          NLigne={NLigne}
        />
      </div>

      <div className="row layout-spacing  bg-white  ">
        {showDepots && (
          <div className="col-lg-6   bg-white  ">
            <Form>
              <Form.Check
                type="switch"
                id="custom-switch"
                label={t(
                  "Consultez le stock des dépôts des articles défectueux",
                )}
                checked={article_defectueux}
                onChange={handleSwitchChange}
              />
            </Form>
          </div>
        )}
        <div className="col-lg-6   bg-white  ">
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              label={t("Consultez le stock 0")}
              checked={showtotalStock}
              onChange={() => setShowtotalStock(!showtotalStock)}
            />
          </Form>
        </div>
        <div className="col-lg-12    ">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <th colSpan={4}></th>

                <th
                  style={{
                    borderRight: "1px solid black",
                  }}
                ></th>
                {true && (
                  <th
                    colSpan={
                      showDepots && OrgDepots === "null"
                        ? listDepots["null"]?.length
                        : 1
                    }
                    onClick={() => {
                      setOrgDepots(OrgDepots === null ? "null" : null);
                      setshowDepots(!showDepots);
                    }}
                    className="lien-bleu-souligne  fixed-width"
                    style={{
                      borderRight: "1px solid black",
                    }}
                  >
                    {t(parametrage?.Desc_Societe)}
                    <p>{StockOrganisation(stock, "null")}</p>
                  </th>
                )}
                {visibleOrganisations &&
                  visibleOrganisations?.map((item, index) => (
                    <>
                      {true && (
                        <>
                          <th
                            className="text-center lien-bleu-souligne fixed-width "
                            style={{
                              borderRight: "1px solid black",
                              backgroundColor: generateUniqueColor(index),
                            }}
                            colSpan={
                              showDepots && OrgDepots === item._id
                                ? article_defectueux
                                  ? listDepots[item._id]?.length
                                  : listDepots[item._id]?.length - 1
                                : 1
                            }
                            onClick={() => {
                              setOrgDepots(
                                OrgDepots === null ? item._id : null,
                              );
                              setshowDepots(!showDepots);
                            }}
                          >
                            {
                              visibleOrganisations?.find(
                                (org) => org._id === item._id,
                              )?.nom
                            }{" "}
                            <p>{StockOrganisation(stock, item._id)}</p>
                          </th>
                        </>
                      )}
                    </>
                  ))}
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: "17px",
                    }}
                  >
                    {t("Code a barre")}
                  </td>
                  <td
                    style={{
                      fontSize: "17px",
                      borderRight: "1px solid black",
                    }}
                    colSpan={2}
                  >
                    <strong>{t("Article")}</strong>
                  </td>
                  <td
                    style={{
                      fontSize: "17px",
                      borderRight: "1px solid black",
                    }}
                  >
                    <strong>{t("Prix")}</strong>
                  </td>
                  <td
                    style={{
                      borderRight: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    <strong>
                      {t("Stock total")} {calculerTotalStock(stock)}
                    </strong>
                  </td>
                  <>
                    {true && (
                      <>
                        {showDepots && OrgDepots === "null" ? (
                          <>
                            {listDepots["null"] ? (
                              listDepots["null"]?.map((dep: any) =>
                                !dep.article_defectueux ? (
                                  <>
                                    <td
                                      style={{
                                        borderRight: "1px solid black",
                                        fontSize: "17px",
                                      }}
                                      key={dep._id}
                                    >
                                      {dep.libelle}
                                    </td>
                                  </>
                                ) : (
                                  article_defectueux && (
                                    <>
                                      <td
                                        style={{
                                          fontSize: "17px",
                                          borderRight: "1px solid black",
                                        }}
                                        key={dep._id}
                                      >
                                        {t("P.Def")}
                                      </td>
                                    </>
                                  )
                                ),
                              )
                            ) : (
                              <td></td>
                            )}
                          </>
                        ) : (
                          <>
                            <td
                              style={{
                                borderRight: "1px solid black",
                              }}
                            ></td>
                          </>
                        )}
                      </>
                    )}
                  </>
                  {visibleOrganisations.map(
                    (item: any, index) =>
                      true && (
                        <>
                          {showDepots && OrgDepots === item._id ? (
                            <>
                              {listDepots[item._id] ? (
                                listDepots[item._id]?.map((dep: any) =>
                                  !dep.article_defectueux ? (
                                    <>
                                      <td
                                        style={{
                                          borderRight: "1px solid black",
                                          fontSize: "17px",
                                          backgroundColor:
                                            generateUniqueColor(index),
                                        }}
                                        key={dep._id}
                                      >
                                        {dep.libelle}
                                      </td>
                                    </>
                                  ) : (
                                    article_defectueux && (
                                      <>
                                        <td
                                          style={{
                                            fontSize: "17px",
                                            borderRight: "1px solid black",
                                            backgroundColor:
                                              generateUniqueColor(index),
                                          }}
                                          key={dep._id}
                                        >
                                          {t("P.Def")}
                                        </td>
                                      </>
                                    )
                                  ),
                                )
                              ) : (
                                <td></td>
                              )}
                            </>
                          ) : (
                            <>
                              <td
                                style={{
                                  borderRight: "1px solid black",
                                }}
                              ></td>
                            </>
                          )}
                        </>
                      ),
                  )}
                </tr>

                {stock &&
                  stock !== null &&
                  stock?.map(
                    (itemdata: any, dataIndex: any) =>
                      (showtotalStock ||
                        StockArticle(itemdata) !== 0 ||
                        findStockPositiveOrg(itemdata) ||
                        findAvanceTransfer(itemdata.article._id, stock)) && (
                        <tr
                          key={dataIndex}
                          style={{
                            fontSize: "17px",
                            fontWeight: "bold",
                          }}
                        >
                          <td style={{ borderTop: "1px solid black" }}>
                            {itemdata?.article?.code_a_barre[0]}
                          </td>
                          <td style={{ borderTop: "1px solid black" }}>
                            {itemdata?.article?.image &&
                            itemdata?.article?.image !== null &&
                            itemdata?.article?.image?.length > 0 ? (
                              <>
                                <Zoom>
                                  <img
                                    alt="image"
                                    src={
                                      process.env.REACT_APP_API_PUBLIC_URL +
                                      "article/" +
                                      itemdata?.article.image
                                    }
                                    width="30"
                                    height="30"
                                  />
                                </Zoom>
                              </>
                            ) : (
                              <>
                                <img
                                  src="assets/assets/img/no-image.jpg"
                                  className="card-img-top"
                                  alt="..."
                                  style={{ width: "50px", height: "30px" }}
                                />
                              </>
                            )}
                          </td>
                          <td
                            style={{
                              fontSize: "17px",
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                            }}
                          >
                            <p style={{ width: "100%" }}>
                              {itemdata?.article?.titre?.fr}
                            </p>
                          </td>
                          <td
                            style={{
                              fontSize: "17px",
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                            }}
                            className="fontBolde "
                          >
                            {itemdata?.article?.prix_vente_ttc?.toFixed(3)}
                          </td>
                          <td
                            style={{
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                              fontSize: "17px",
                            }}
                            className="fontBolde "
                          >
                            {" "}
                            <p>{StockArticle(itemdata)}</p>
                          </td>
                          {/**(showtotalStock ||
                                StockOrganisation(stock, orgId._id) > 0) */}
                          <React.Fragment key={index}>
                            {true &&
                              (showDepots && "null" === OrgDepots ? (
                                <React.Fragment key={index}>
                                  {listDepots["null"] ? (
                                    listDepots["null"]?.map(
                                      (dep: any, index: any) => (
                                        <React.Fragment key={index}>
                                          {!dep.article_defectueux ? (
                                            <>
                                              <td
                                                className="fontBolde "
                                                onClick={() => {
                                                  setOrgDepots(null);
                                                  setshowDepots(!showDepots);
                                                }}
                                                style={{
                                                  borderRight:
                                                    "1px solid black",
                                                  borderTop: "1px solid black",
                                                }}
                                              >
                                                {calculstock(
                                                  itemdata,
                                                  "null",
                                                  dep,
                                                )}
                                              </td>
                                            </>
                                          ) : (
                                            article_defectueux && (
                                              <td
                                                className="fontBolde "
                                                style={{
                                                  borderRight:
                                                    "1px solid black",
                                                  borderTop: "1px solid black",
                                                }}
                                                onClick={() => {
                                                  setOrgDepots(null);
                                                  setshowDepots(!showDepots);
                                                }}
                                              >
                                                {itemdata?.stock["null"]?.find(
                                                  (d: any) =>
                                                    d.depots_id
                                                      .article_defectueux,
                                                )?.stock || 0}
                                              </td>
                                            )
                                          )}
                                        </React.Fragment>
                                      ),
                                    )
                                  ) : (
                                    <td></td>
                                  )}
                                </React.Fragment>
                              ) : (
                                <>
                                  <td
                                    className="fontBolde "
                                    onClick={() => {
                                      setOrgDepots("null");
                                      setshowDepots(!showDepots);
                                    }}
                                    style={{
                                      borderRight: "1px solid black",
                                      borderTop: "1px solid black",
                                    }}
                                  >
                                    {calculstockOrga(itemdata, "null")}
                                  </td>
                                </>
                              ))}
                          </React.Fragment>
                          {visibleOrganisations?.map((orgId, indOrg) => (
                            <React.Fragment key={indOrg}>
                              {true &&
                                (showDepots && orgId._id === OrgDepots ? (
                                  <React.Fragment key={indOrg}>
                                    {listDepots[orgId._id] ? (
                                      listDepots[orgId._id]?.map(
                                        (dep: any, index: any) => (
                                          <React.Fragment key={index}>
                                            {!dep.article_defectueux ? (
                                              <>
                                                <td
                                                  className="fontBolde "
                                                  onClick={() => {
                                                    setOrgDepots(null);
                                                    setshowDepots(!showDepots);
                                                  }}
                                                  style={{
                                                    borderRight:
                                                      "1px solid black",
                                                    borderTop:
                                                      "1px solid black",
                                                    backgroundColor:
                                                      generateUniqueColor(
                                                        indOrg,
                                                      ),
                                                  }}
                                                >
                                                  {/** */}
                                                  {calculstock(
                                                    itemdata,
                                                    orgId._id,
                                                    dep,
                                                  )}
                                                </td>
                                              </>
                                            ) : (
                                              article_defectueux && (
                                                <td
                                                  className="fontBolde "
                                                  style={{
                                                    borderRight:
                                                      "1px solid black",
                                                    borderTop:
                                                      "1px solid black",
                                                    backgroundColor:
                                                      generateUniqueColor(
                                                        indOrg,
                                                      ),
                                                  }}
                                                  onClick={() => {
                                                    setOrgDepots(null);
                                                    setshowDepots(!showDepots);
                                                  }}
                                                >
                                                  {itemdata?.stock[
                                                    orgId._id
                                                  ]?.find(
                                                    (d: any) =>
                                                      d.depots_id
                                                        .article_defectueux,
                                                  )?.stock || 0}
                                                </td>
                                              )
                                            )}
                                          </React.Fragment>
                                        ),
                                      )
                                    ) : (
                                      <td></td>
                                    )}
                                  </React.Fragment>
                                ) : (
                                  <>
                                    <td
                                      className="fontBolde "
                                      onClick={() => {
                                        setOrgDepots(orgId._id);
                                        setshowDepots(!showDepots);
                                      }}
                                      style={{
                                        borderRight: "1px solid black",
                                        borderTop: "1px solid black",
                                        backgroundColor:
                                          generateUniqueColor(indOrg),
                                      }}
                                    >
                                      {calculstockOrga(itemdata, orgId._id)}
                                    </td>
                                  </>
                                ))}
                            </React.Fragment>
                          ))}
                        </tr>
                      ),
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
/*   <td key={key}> {/* Ensure each cell has a unique key */
//{stock.find((st: any) => (
//  st.depots_id._id === key && // Check if depots_id matches the current key
//st.article_id !== null && // Ensure article_id is not null
// st.article_id._id === item.article_id._id// Check if article_id matches the specific ID
//))?.stock || key}
//</td>*/
/*          {lists.map((item , indexl)=> (
    <tr key={indexl}> 
    <td>{item.article._id}</td>
    {list_depots.map((element:any , index:number) => (
        <td key={index}>{item[element]}</td>
    ))}
</tr>
))}*/
